import React from "react";
import { AdminProductQuery, useUpdateProductMutation } from "@apollo/ops";
import { Button } from "@ui/Button";
import { Dialog, useDialog } from "@ui/Dialog";
import { ProductForm, UpdateProductFormData } from "../ProductForm";
import { toast } from "@utilities/toast";
import { MessageSeverity } from "@shared/types/Severity";
import { getMessageToUserFromBackendError } from "@utilities/i18n";
import { toCents } from "@util/currency";
import _ from "lodash";

type UpdateProductDialogProps = {
  product: AdminProductQuery["product"];
};

export function UpdateProductDialog({ product }: UpdateProductDialogProps) {
  const { open, close, getDialogProps } = useDialog();
  const [updateProductMutation] = useUpdateProductMutation();

  const handleSubmit = async ({
    name,
    abv,
    packageDate,
    rating,
    description,
    breweryNetPrice,
    cloudinaryImageId,
    beerStyleId,
  }: UpdateProductFormData) => {
    try {
      const result = await updateProductMutation({
        variables: {
          data: {
            id: product.id,
            name,
            abv: _.isNil(abv) ? null : parseFloat(abv),
            packageDate,
            rating: _.isNil(rating) ? null : parseFloat(rating),
            description,
            breweryNetPrice: _.isNil(breweryNetPrice)
              ? null
              : toCents(breweryNetPrice),
            beerStyleId,
            cloudinaryImageId,
          },
        },
      });
      if (result.data) {
        close();

        toast.current?.show({
          severity: MessageSeverity.success,
          summary: "",
          detail: `Updated Product ${name}`,
        });
      }
    } catch (error) {
      toast.current?.show({
        severity: MessageSeverity.error,
        summary: getMessageToUserFromBackendError(error),
      });
    }
  };

  return (
    <>
      <Button kind="primary" onClick={open} size="sm">
        Edit
      </Button>
      <Dialog {...getDialogProps()} title={`Edit ${product.name}`} width="lg">
        <ProductForm
          onSubmit={handleSubmit}
          product={product}
          isEditing={true}
        />
      </Dialog>
    </>
  );
}
